<template>
    <div id="tl-app">
        <PageLoader />
        <router-view />
        <CommonModal />
        <WidgetModalContainer />
        <Toast
            position="bottom-right"
            group="tl"
            append-to="#app"
            :success-icon="TOAST_SUCCESS_ICON"
            :error-icon="TOAST_ERROR_ICON"
            :pt="{
                root: { 'data-testid': 'tl-toast' },
                messageContent: { 'data-testid': 'tl-toast-content' },
                closeButton: { 'data-testid': 'tl-toast-close-button' },
            }"
        >
            <template #messageicon="slotProps">
                <i :class="slotProps.class" />
            </template>
            <template #closeicon="slotProps">
                <i :class="[slotProps.class, TOAST_CLOSE_ICON]" />
            </template>
        </Toast>
        <GatewayTimeoutToast />
        <div id="widget" />
    </div>
</template>

<script setup lang="ts">
import PageLoader from '@/components/panel/PageLoader.vue'
import CommonModal from '@/components/atoms/CommonModal.vue'
import WidgetModalContainer from '@/components/molecules/WidgetModalContainer.vue'
import GatewayTimeoutToast from './modules/errors/components/GatewayTimeoutToast.vue'
import { useToast } from 'primevue/usetoast'
import { setToastInstance } from '@/composables/notifications/toast-instance'
import { onMounted } from 'vue'
import '@/styles/fonts.css'

const TOAST_SUCCESS_ICON = 'tli-approve-check'
const TOAST_ERROR_ICON = 'tli-close'
const TOAST_CLOSE_ICON = 'tli-close'

onMounted(() => {
    const toast = useToast()
    setToastInstance(toast)
})
</script>

<style lang="sass" scoped>
#tl-app
    transition: all .2s
    min-height: 100vh
    display: block
    position: relative
</style>
